<script>
  import { createEventDispatcher } from 'svelte';
  export let answer = { fullAnswer: '', usageData: null };
  export let answerText;
  export let isLoading;
  export let results = [];

  const dispatch = createEventDispatcher();

  function processCitations(text) {
    return text.replace(/\[(\d+)\]/g, (match, p1) => {
      const index = parseInt(p1) - 1;
      if (results[index]) {
        return `<a href="${results[index].url}" target="_blank" rel="noopener noreferrer">[${p1}]</a>`;
      }
      return match;
    });
  }

  $: paragraphs = (() => {
    let textToProcess = '';
    if (typeof answer === 'string') {
      textToProcess = answer;
    } else if (answer?.fullAnswer) {
      textToProcess = answer.fullAnswer;
    }

    if (textToProcess) {
      return textToProcess.split('\n\n').map(processCitations);
    }

    return [];
  })();

</script>

<style>
  .answer h3 {
    font-size: 1.3em;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .answer-content {
    margin-top: 10px;
  }

  .loading {
    color: #666;
    font-style: italic;
  }

  :global(.answer-content a) {
    color: #003476;
    text-decoration: none;
  }

  :global(.answer-content a:hover) {
    text-decoration: underline;
  }

  :global(.answer-content p) {
    margin-bottom: 1em;
  }
</style>

{#if (typeof answer === 'string' && answer.trim() !== '') || (answer?.fullAnswer && answer.fullAnswer.trim() !== '')}
  <div class="answer">
    <h3>{answerText}</h3>
    <div class="answer-content">
      {#if isLoading}
        <p class="loading">Loading answer...</p>
      {:else}
        {#each paragraphs as paragraph}
          <p>{@html paragraph}</p>
        {/each}
      {/if}
    </div>
  </div>
{/if}